// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--EhODX";
export var secondary = "heading-module--secondary--IRbbr";
export var center = "heading-module--center--J0yzp";